import { FC } from 'react';
import { CreateDestinationContent } from './createDestinationContent';

export const CreateDestinationV2: FC = () => {
  return <CreateDestinationContent></CreateDestinationContent>;
};
